
import { Route, Routes, useLocation } from "react-router-dom"
import { Box } from "@mui/material";
import { CheckoutCliente, FloatingActionButtom } from "../components/home/components";
import { Footer } from "../components/ui/Footer"
import { Navbar } from "../components/ui/Navbar"
import { ModalCarritoCliente } from '../components/ui/ModalCarritoCliente';


// Paginas de Home
import { DashboardCliene, RastrearOP, MisPedidos, MisArchivados, MiPerfil, DetallesOpCliente, 
        NoPagesFound, HomeScreen, ContactenosScreen, DetalleProductoCliente, CotizarCliente,
        CategoriaScreenCliente, ExibirProductosCliente, 
        ComprarAhoraCliente } from "../components/home/pages";


import { LoginClientes } from "../components/auth/pages";
import { CambioClave } from "../components/dashboard/pages";





import { DetalleItemCompra } from "../components/compras/pages";
import { AbonosCliente } from "../components/home/AbonosCliente"
import { ImagenPago } from "../components/home/ImagenPago"
import { useGlobalValueStore } from "../stores";
import { useEffect } from "react";




export const HomeRouter = () => {


    const location = useLocation();
    const rutaActual = location.pathname;
    const { cambiarPageCliente } = useGlobalValueStore();


    useEffect(() => {
        if( rutaActual !== '/login' ){ cambiarPageCliente(rutaActual) }
    }, [rutaActual]);


    return (
        <Box sx={{width:'100%'}}>
            <Navbar />
            <FloatingActionButtom />

            <Routes>
                {/* Primera Ruta Home */}
                <Route path="/" element={<HomeScreen />} />
                <Route path="/contactos" element={<ContactenosScreen />} />
                <Route path="/login" element={<LoginClientes />} />
                <Route path="/restrearop" element={<RastrearOP />} />


                {/* Productos de compra cliente final */}
                <Route path="/categorias" element={<CategoriaScreenCliente />} />
                <Route path="/filtro/:id" element={<ExibirProductosCliente />} />
                <Route path="/detproventa/:cat/:prod" element={<DetalleProductoCliente />} />
                <Route path="/comprar-cliente"  element={ <ComprarAhoraCliente />} />
                {/* Configuraciones de Perfil */}
                <Route path="/dashboard" element={<DashboardCliene />} />
                <Route path="/perfil" element={<MiPerfil />} />
                <Route path="/detalle-item/:id" element={<Box sx={{px:5, pt:4, pb:2}}><DetalleItemCompra /></Box> }/>
                <Route path="/cambio-password" element={<Box sx={{px:5, pt:4, pb:2}}><CambioClave /></Box> }/>








                <Route path="/mis-pedidos" element={<MisPedidos />} />
                <Route path="/detallesop/:id" element={<DetallesOpCliente />} />
                <Route path="/mis-archivados" element={<MisArchivados />} />
                {/* Rutas de Comprar Ahora */}
                <Route path="/checkout-cliente" element={<Box sx={{px:2, mt:5, mb:9}}><CheckoutCliente /></Box> }/>
                <Route  path="/cotizar" element={<Box sx={{px:2, mt:6, mb:9}}><CotizarCliente /></Box> }/>
                {/* <div className="formTodoOp"> */}
                <Route path="/foto-pago/:id" element={<ImagenPago />} />
                <Route path="/abono-cliente/:id" element={<AbonosCliente />} />


                <Route path="*" element={<NoPagesFound />} />
            </Routes>



            <ModalCarritoCliente />
            <Footer />
        </Box>
    )
}
